export default "__VITE_ASSET__DikSiY8O__"